module.exports = __webpack_public_path__ + "img/door-sensor.710c0188.svg";